
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 3.5a1 1 0 0 0-1 1v12.987a1 1 0 0 0 1 1h6.3c.443 0 .873.18 1.194.508.321.329.506.78.506 1.255a1 1 0 1 0 2 0c0-.475.185-.926.506-1.255a1.67 1.67 0 0 1 1.194-.508H21a1 1 0 0 0 1-1V4.5a1 1 0 0 0-1-1h-5.4A4.559 4.559 0 0 0 12 5.268 4.559 4.559 0 0 0 8.4 3.5H3Zm10 13.407a3.65 3.65 0 0 1 1.7-.42H20V5.5h-4.4c-.682 0-1.34.277-1.83.778A2.729 2.729 0 0 0 13 8.184v8.723Zm-2 0V8.184c0-.719-.28-1.404-.77-1.906A2.559 2.559 0 0 0 8.4 5.5H4v10.987h5.3c.599 0 1.18.147 1.7.42Z","fill":"currentColor"}})])
          )
        }
      }
    